import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Volume2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { CustomerAudioLibrary } from "../components/mbox/CustomerAudioLibrary";
import { CustomerEventAudioList } from "../components/mbox/CustomerEventAudioList";
import { Logo } from "../components/Logo";

// Kundenseite "Durchsagen verwalten": reine Audiodatei-Verwaltung (Datenbank der Kundennummer + Verknuepfung je Veranstaltung).
// Abspielen/Stopp/Timer auf den Masten liegt in der Kachel "Event".
export default function DurchsagenPage() {
  const navigate = useNavigate();
  const [rev, setRev] = useState(0);
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-30">
        <div className="max-w-5xl mx-auto px-3 sm:px-4 py-2.5 sm:py-3 flex items-center gap-2 sm:gap-3">
          <Button variant="ghost" size="sm" onClick={() => navigate("/hub")} className="text-gray-600 hover:text-fuchsia-600 px-2" data-testid="durchsagen-back-btn">
            <ArrowLeft className="w-4 h-4 sm:mr-1" /><span className="hidden sm:inline">Zurück</span>
          </Button>
          <div className="min-w-0">
            <h1 className="text-base font-bold text-gray-900 flex items-center gap-2"><Volume2 className="w-5 h-5 text-fuchsia-600" /> Durchsagen Verwaltung</h1>
            <p className="text-xs text-gray-400 truncate">Sprachdateien speichern, vorhören und mit Veranstaltungen verknüpfen</p>
          </div>
          <div className="ml-auto hidden sm:block"><Logo size="small" /></div>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-3 sm:px-4 py-4 sm:py-6 space-y-4 sm:space-y-6">
        <CustomerAudioLibrary onOrdersChanged={() => setRev(r => r + 1)} />
        <CustomerEventAudioList rev={rev} />
      </main>
    </div>
  );
}
